import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Languages, X } from "lucide-react";
import { pathInOtherLocale, pathLocale } from "../i18n/useT";

const DISMISS_KEY = "sv4-locale-banner-dismissed";

/**
 * Suggests Spanish to first-time visitors whose browser locale starts with "es"
 * — only when they're on an English route. Dismissible via X (sessionStorage).
 * Never auto-redirects.
 */
export default function LocaleSuggestionBanner() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem(DISMISS_KEY)) return;
    if (pathLocale(pathname) !== "en") return;
    if (!navigator.language?.toLowerCase().startsWith("es")) return;
    setShow(true);
  }, [pathname]);

  if (!show) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, "1");
    } catch {
      // ignore (private mode etc.)
    }
    setShow(false);
  };

  const esPath = pathInOtherLocale(pathname);

  return (
    <div className="border-b border-ink-800/60 bg-ink-900/80 backdrop-blur">
      <div className="container-page flex items-center justify-between gap-4 py-2.5 text-sm">
        <p className="flex items-center gap-2 text-ink-300">
          <Languages className="size-4 text-accent-400 shrink-0" />
          <span>
            Esta página también está disponible en{" "}
            <Link
              to={esPath}
              onClick={dismiss}
              className="font-semibold text-accent-400 underline-offset-2 hover:underline"
            >
              español
            </Link>
            .
          </span>
        </p>
        <button
          onClick={dismiss}
          className="rounded-md p-1.5 text-ink-400 hover:bg-ink-800 hover:text-ink-100 transition"
          aria-label="Dismiss"
        >
          <X className="size-4" />
        </button>
      </div>
    </div>
  );
}
